import { useState, useEffect } from "react";
import axios, { CancelToken } from "axios";
import { BANK_ACCOUNTS } from "../../../../constants/api";
import { useIntl } from "react-intl";

const useBankAccount = () => {
  const [bankAccounts, setBankAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const intl = useIntl();

  const getBankAccounts = async (source) => {
    try {
      setLoading(true);

      const response = await axios.get(BANK_ACCOUNTS, {
        cancelToken: source?.token,
      });

      if (response?.data?.success) {
        setBankAccounts(response?.data?.result.slice(0, 50));
      }
    } catch (err) {
      setError(
        err.message || intl.formatMessage({ id: "errors.somethingWrong" })
      );
    } finally {
      setLoading(false);
    }
  };

  const setDefaultBankAccount = async (bankAccountId) => {
    setBankAccounts(
      bankAccounts.map((bankAccount) => ({
        ...bankAccount,
        default: bankAccount.id === bankAccountId,
      }))
    );
  };

  const addBankAccount = (bankAccount) => {
    setBankAccounts([...bankAccounts, bankAccount]);
  };

  useEffect(() => {
    const source = CancelToken.source();

    getBankAccounts(source);

    return () => {
      source.cancel("Component unmounted");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    getBankAccounts,
    addBankAccount,
    setDefaultBankAccount,
    bankAccounts,
    loading,
    error,
  };
};

export default useBankAccount;
